import { render, staticRenderFns } from "./congratulations.vue?vue&type=template&id=5233c989&scoped=true"
import script from "./congratulations.vue?vue&type=script&lang=js"
export * from "./congratulations.vue?vue&type=script&lang=js"
import style0 from "./congratulations.vue?vue&type=style&index=0&id=5233c989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233c989",
  null
  
)

export default component.exports